export default __webpack_public_path__ + "static/media/case_study_mcdonalds.f68942de.mp4";